import {
  ComponentFactoryResolver,
  ComponentRef, ElementRef,
  Injectable,
  Injector,
  TemplateRef,
  ViewContainerRef, ViewRef
} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {IIntPortalOutletItem} from "./types";
import {IntPortalTemplateWrapComponent} from "./int-portal-template-wrap.component";

@Injectable(
  {providedIn: 'root'}
)
export class IntPortalOutletService {

  directiveViewContainerRef!: ViewContainerRef;

  templates$ = new BehaviorSubject<IIntPortalOutletItem[]>([]);

  elementsMap = new WeakMap();

  delayMap = new WeakMap();

  /**/
  templateMap: WeakMap<TemplateRef<any>, ViewRef> = new WeakMap<TemplateRef<any>, ViewRef>();
  /**/

  constructor(
    private readonly injector: Injector,
    private cfr: ComponentFactoryResolver
  ) {}

  setRoot(root: ViewContainerRef) {
    this.directiveViewContainerRef = root;
  }

  isTemplateExist(key: string): boolean {
    return !this.templates$.value.find(t => t.key === key)
  }

  setTemplate<T>(template: TemplateRef<any>, key: string, payload?: T) {
    if(this.isTemplateExist(key)) {
      this.templates$.next([...this.templates$.value, {
        template, key, payload
      }]);
    }
  }

  removeTemplate(key: string) {
    this.templates$.next(this.templates$.value.filter(template => template.key !== key))
  }

  setTemplateAsComponent<P, A>(template: TemplateRef<A>, payload?: P): ElementRef<any> {
    const componentFactory = this.cfr.resolveComponentFactory(
      IntPortalTemplateWrapComponent
    );

    const componentRef = this.directiveViewContainerRef?.createComponent(
      componentFactory,
      0,
      this.injector
    );

    componentRef.instance.context = payload;
    componentRef.instance.content = template;
    componentRef.changeDetectorRef.detectChanges();

    this.elementsMap.set(template, componentRef);

    const elementRef = componentRef?.location;

    return elementRef;
  }
  removeComponent<A>(template: TemplateRef<A>) {
    if (this.elementsMap.has(template)) {
      this.elementsMap.get(template).destroy();
      this.elementsMap.delete(template);
    }
  }

  /*
  * Set template and get insert component links
  *  */
  setTemplateOut<T>(
    template: TemplateRef<any>,
    payload?: T,
    delay: number = 0
  ): Array<HTMLElement> | null {
    if (!this.directiveViewContainerRef || this.templateMap.has(template)) {
      return null;
    }
    //const view = this.directiveViewContainerRef.createEmbeddedView(template, {$implicit: payload})
    const view = template.createEmbeddedView({$implicit: payload});
    //console.log(view, _view)
    this.templateMap.set(template, view);
    this.directiveViewContainerRef.insert(view);
    return view.rootNodes;
  }

  removeTemplateOut<T>(template: TemplateRef<T>) {
    const view = this.templateMap.has(template) ? this.templateMap.get(template) : null;
    if (view) {
      const index = this.directiveViewContainerRef.indexOf(view);
      this.directiveViewContainerRef.remove(index);
      this.templateMap.delete(template);
      view.destroy();
    }
  }
}
